import { colors } from '@theme/foundations/colors';

type Props = {
  isConnected: boolean;
  x: number;
  y: number;
  orientation?: 'vertical' | 'horizontal';
  onClick?: () => void;
};

export default function Gate({ isConnected, x, y, orientation = 'vertical', onClick }: Readonly<Props>) {
  if (orientation === 'horizontal') {
    return (
      <svg
        width="34"
        height="23"
        viewBox="0 0 34 23"
        fill="none"
        x={x}
        y={y}
        style={{ cursor: onClick ? 'pointer' : 'default' }}
        onClick={onClick}
      >
        <rect y={1} x={-3} width="40" height="31" fill="transparent" />
        <circle
          cx="3"
          cy="3"
          r="3"
          transform="matrix(-1 0 0 1 32.5 13.5)"
          stroke={colors.neutral['200'].value}
          strokeWidth="2"
        />
        <circle
          cx="3"
          cy="3"
          r="3"
          transform="matrix(-1 0 0 1 7.5 13.5)"
          stroke={colors.neutral['200'].value}
          strokeWidth="2"
        />
        {isConnected ? (
          <line
            y1="-1"
            x2="26.3059"
            y2="-1"
            transform="matrix(-0.988372 0.152057 0.152057 0.988372 33.5 12.5)"
            stroke={colors.neutral['200'].value}
            strokeWidth="2"
          />
        ) : (
          <line
            y1="-1"
            x2="27.4807"
            y2="-1"
            transform="matrix(-0.847471 0.530842 0.530842 0.847471 30.7891 1.91211)"
            stroke={colors.neutral['200'].value}
            strokeWidth="2"
          />
        )}
      </svg>
    );
  }
  return (
    <svg
      width="23"
      height="34"
      viewBox="0 0 23 34"
      fill="none"
      x={x}
      y={y}
      pointerEvents="all"
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
    >
      <rect x={1} y={-3} width="31" height="40" fill="transparent" />
      <circle
        cx="17"
        cy="29.5"
        r="3"
        transform="rotate(-90 17 29.5)"
        stroke={colors.neutral['200'].value}
        strokeWidth="2"
      />
      <circle
        cx="17"
        cy="4.5"
        r="3"
        transform="rotate(-90 17 4.5)"
        stroke={colors.neutral['200'].value}
        strokeWidth="2"
      />
      {isConnected ? (
        <line
          x1="12.0116"
          y1="33.3479"
          x2="16.0116"
          y2="7.34794"
          stroke={colors.neutral['200'].value}
          strokeWidth="2"
        />
      ) : (
        <line
          x1="1.56464"
          y1="30.2582"
          x2="16.1525"
          y2="6.96916"
          stroke={colors.neutral['200'].value}
          strokeWidth="2"
        />
      )}
    </svg>
  );
}
